import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import ManageFolders from "./routes/ManageFolders";
export default store => {
  return {
    path: "feed/:learnerPortfolioId",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import("./components"),
          import("LearnerPortfolio/modules/LearnerPortfolioModule"),
          import("Post/modules/PostModule"),
        ]).then(([importedModule0, importedModule1, importedModule2]) => {
          const component = importedModule0.default;
          const reducer = importedModule1;
          const post = importedModule2.default;
          injectReducer(store, {
            key: reducer.NAME,
            reducer: reducer.default,
          });
          injectReducer(store, {
            key: "post",
            reducer: post,
          });
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [ManageFolders(store)],
  };
};
